import axios from 'axios'
import {config as AppConfig} from '../config'
import {store} from '../../index';
import {history} from '../../App';


axios.defaults.withCredentials = true;
const axiosService = axios.create({
    //creates a new instance of axios with custom config
    //When needing to use this custom config, import from axiosService from 'lib/axios or something
    //if that import doesn't work try '/lib/axios/index
    //also don't forget to import AxiosResponse and AxiosError from axios itself
    baseURL: process.env.NODE_ENV ==='development' ? AppConfig.dev.baseUrl + AppConfig.dev.appName : AppConfig.build.baseUrl + AppConfig.build.appName,
    timeout: process.env.NODE_ENV ==='development' ? AppConfig.dev.httpApiServiceTimeOut : AppConfig.build.httpApiServiceTimeOut,

});

axiosService.interceptors.request.use((config) => {
    //this is where the program will intercept the http and slap a jwt token on the end of it to authenticate the user with the backend API


    //Get JWT token from redux store and add to the request headers
    // let accessTokenFromReduxState = useSelector((state: ApplicationState) => state.authenticationState.authSettings?.accessToken);
    // accessTokenFromReduxState = ''; /cannot use hook here as not in body of functional component, store.getState used instead
    const accessTokenFromReduxState = store.getState().authenticationState && store.getState().authenticationState.authSettings ? store.getState().authenticationState.authSettings?.accessToken : '';
 

    if(config.headers === undefined) {
        config.headers = {};
    }
    config.headers.Authorization = `Bearer ${accessTokenFromReduxState}`;

    return config;
});
axiosService.interceptors.response.use(
    //intercepts any http requests before they are sent and does the following code to them
    //https://axios-http.com/docs/interceptors
    //if response is good ignore
    response => response,
    //if there's an error do the following
    error => {
        //const navigate = useNavigate();

        if (error.response.status === 401) {
            //handle a 401. Hubstaff uses cookieExpirationDates, if they get used then remove then here on auth failure
            //send users back to the login page and clear any state (cookies etc) as it means user is unauthorised.
            //token might have expired so user will need to login
            //navigate('/');;
            // <Navigate to='/' />
            history.push('/');
        }
            
        else {
            //Reject the inprogress promise if the error is anything other an unauthorised(401)
            return Promise.reject(error);
        }
    }
)


export default axiosService;